import {
  CuePoint,
  CuePointMetadata,
  CuePointSettings,
  CuePointSourceProperty,
  CuePointType,
  SourceWithoutProperties
} from '../presentation-config-aggregate-types/presentation-config-aggregate-types';
import { makeAutoObservable } from 'mobx';
import { AssetInPropertiesHolder } from '../asset-in-properties-holder/asset-in-properties-holder';

class CuePointEntity {
  private time: number;
  private type: CuePointType;
  private source: SourceWithoutProperties;
  private settings: CuePointSettings;
  private metadata: CuePointMetadata;
  private properties: CuePointSourceProperty[];
  private assetHolder: AssetInPropertiesHolder;

  constructor (fromDTO: CuePoint = {} as CuePoint) {
    makeAutoObservable(this);
    this.deserialize(fromDTO);
  }

  public getCuePointId (): string {
    return this.assetHolder.getCuePointId();
  }

  public getMetadata (): CuePointMetadata {
    return this.metadata;
  }

  public setMetadata (metadata: CuePointMetadata): void {
    this.metadata = metadata;
  }

  public getSource (): SourceWithoutProperties {
    return this.source;
  }

  public serialize = (): CuePoint => {
    return {
      time: this.time,
      type: this.type,
      settings: { ...this.settings },
      metadata: {
        ...this.metadata,
        largeThumbnail: this.metadata.largeThumbnail || this.metadata.smallThumbnail,
      },
      source: {
        ...this.source,
        properties: {
          // consider filtering content elements out on deserialization if this is some 'legacy' stuff
          property : this.properties.filter(x => x.name !== 'content'),
        },
      },
    };
  };

  private deserialize = (fromDTO: CuePoint): void => {
    this.time = fromDTO.time || 0;
    this.type = fromDTO.type || CuePointType.blank;
    this.settings = fromDTO.settings;
    this.metadata = fromDTO.metadata;

    this.properties = [];
    let sourceWithoutProperties = null;
    if (fromDTO.source) {
      if (fromDTO.source.properties && fromDTO.source.properties.property) {
        this.properties.push(...fromDTO.source.properties.property);
      }

      sourceWithoutProperties = {
        url: fromDTO.source.url,
        image: fromDTO.source.image,
      };
    }

    this.assetHolder = new AssetInPropertiesHolder(this.properties);

    this.source = {
      url: '',
      image: '',
      ...sourceWithoutProperties,
    };
  };
}

export default CuePointEntity;
